import type { Models, RematchDispatch, RematchRootState } from "@rematch/core";
import application from "./application";
import permissions from "./permissions";
import user from "./user";
import userPermissions from "./userPermissions";

export interface IRootModel extends Models<IRootModel> {
	application: typeof application;
	user: typeof user;
	permissions: typeof permissions;
	userPermissions: typeof userPermissions;
}
export type TDispatch = RematchDispatch<IRootModel>;
export type TRootState = RematchRootState<IRootModel>;
export const models: IRootModel = {
	application,
	user,
	permissions,
	userPermissions,
};
